import { apiClient } from '@/shared/api';
import type {
  ThemeParameterResponse,
  ThemeValueResponse,
  CreateThemeRequest,
  UpdateThemeRequest,
  ThemeValue,
} from './types';

/**
 * Fetch theme parameter structure (available color parameters grouped in blocks)
 */
export const fetchThemeParameters = async (): Promise<ThemeParameterResponse> => {
  const { data } = await apiClient.get<ThemeParameterResponse>('/theme-parameter');
  return data;
};

/**
 * Fetch theme values (themes with their color values)
 */
export const fetchThemeValues = async (): Promise<ThemeValueResponse> => {
  const { data } = await apiClient.get<ThemeValueResponse>('/theme-value');
  return data;
};

/**
 * Create a new theme
 */
export const createTheme = async (body: CreateThemeRequest): Promise<ThemeValue> => {
  const { data } = await apiClient.post<ThemeValue>('/theme-value', body);
  return data;
};

/**
 * Update an existing theme
 */
export const updateTheme = async (id: number, body: UpdateThemeRequest): Promise<ThemeValue> => {
  const { data } = await apiClient.put<ThemeValue>(`/theme-value/${id}`, body);
  return data;
};

/**
 * Delete a theme
 */
export const deleteTheme = async (id: number): Promise<void> => {
  await apiClient.delete(`/theme-value/${id}`);
};
